module.exports = __webpack_public_path__ + "img/sweden-genitourinary-diseases-female.778abc99.png";